import React, { Component } from 'react';

import { localeStrings as strings } from 'applicationConfig';

class ChangePasswordDescription extends Component {
  render() {
    return (
      <div className={`${this.props.className} `}>
        <b>{strings.changePassword.requirements}</b>

        <p>{strings.changePassword.passwordValidation}</p>
        <p>
          <span>{strings.myAccount.emailInfo} </span>
          <a className="mailto" href={'mailto:' + strings.myAccount.infoEmailAddress}>
            {strings.myAccount.infoEmailAddress}
          </a>
        </p>
      </div>
    );
  }
}

export default ChangePasswordDescription;



// WEBPACK FOOTER //
// ./src/containers/MyAccount/ChangePassword/ChangePasswordDescription.jsx